import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, take, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

/**
 * Guard pour le Dashboard : vérifie isEmployee + ability manager/topManager
 * sur le profil utilisateur (collection users).
 */
@Injectable({
  providedIn: 'root'
})
export class ManagerGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.getUserProfileObservable().pipe(
      take(1),
      map(profile => {
        if (profile?.isEmployee && (profile.ability === 'manager' || profile.ability === 'topManager' || profile.ability === 'super_admin')) {
          return true;
        }
        console.warn('[ManagerGuard] Accès refusé - isEmployee:', profile?.isEmployee, 'ability:', profile?.ability);
        this.router.navigate(['/']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/']);
        return of(false);
      })
    );
  }
}
